import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { Company } from './company';

@Injectable()
export class CompanyService implements Resolve<any> {
  public rows: any;
  public onCompanyListChanged: BehaviorSubject<any>;

  constructor(private _httpClient: HttpClient, public _authenticationService: AuthenticationService) {
    this.onCompanyListChanged = new BehaviorSubject({});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getAllCompanies()]).then(() => {
        resolve();
      }, reject);
    });
  }

  getAllCompanies(): Promise<Company[]> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}/v1/companies`, { headers }).subscribe((response: any) => {
        this.rows = response.results;
        this.onCompanyListChanged.next(this.rows);
        resolve(this.rows);
      }, reject);
    });
  }

  createCompany(company): Promise<void> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${environment.apiUrl}/v1/companies`, company, { headers }).subscribe((response: any) => {
        this.getAllCompanies();
        resolve();
      }, reject);
    });
  }
}
